import * as React from "react";
import { NavLink } from "react-router-dom";

type Props = {
  visible: boolean;
  text: any;
  link: string;
  clearStates: () => void;
};

const BOSideItemSub = ({ visible, text, link, clearStates }: Props) => {
  return (
    <li className={visible ? "shown" : "hidden"}>
      <NavLink
        className="BOSideItemSubLink"
        to={link}
        onClick={clearStates}
        activeClassName="selected"
      >
        <h4 className="BOSideItemSubButton">{text}</h4>
      </NavLink>
    </li>
  );
};

export default BOSideItemSub;

export const BOSideItemSubLoader = () => {
  return (
    <li style={{ textAlign: "center" }}>
      <i className={`fa fa-spinner fa-spin fa-2x fa-fw`} />
    </li>
  );
};
